export default "__VITE_ASSET__J5asGfdJ__"